module.exports = __webpack_public_path__ + "static/media/new-pandas.40298fc2.svg";